<template>

  <div class="adsense-placeholder">
      <Adsense
        v-if="loaded"
        :data-ad-client="dataAdClient"
        :data-ad-slot="dataAdSlot"
        :data-ad-format="dataAdFormat"
        :data-full-width-responsive="dataFullWidthResponsive"
      >
      </Adsense>
  </div>

</template>

<script>

export default {
  name: "ConditionalAdsense",
  props: {
    dataAdClient: String,
    dataAdSlot: String,
    dataAdFormat: String,
    dataFullWidthResponsive: String,
  },
  data() {
    return {
      loaded: false,
    };
  },
  mounted() {
    // Defer ad initialization to avoid blocking early user interactions (INP)
    setTimeout(() => {
      this.loaded = true;
    }, 1500);
  },
};
</script>

<style scoped>

.adsense-placeholder {
  min-height: 280px;
}

</style>
